import React, { useContext, useEffect, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { useModalService } from "./../../ricos-modals/modal-service-provider";
import { ToggleButton } from "./../../toolbars-ui";
import DesignIcon from "../assets/icons/DesignIcon";
const PollDesignButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const [referenceElement, setReferenceElement] = useState(null);
  const [isActive, setIsActive] = useState(toolbarItem.attributes.active);
  const modalService = useModalService();
  useEffect(() => {
    modalService.onModalOpened(() => {
      setIsActive(Boolean(toolbarItem.attributes.active));
    });
    modalService.onModalClosed(() => {
      setIsActive(Boolean(toolbarItem.attributes.active));
    });
  }, [modalService]);
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      Icon: DesignIcon,
      onClick: () => toolbarItem.commands?.click({ referenceElement }),
      dataHook,
      active: isActive,
      tooltip: t("Poll_PollSettings_Tab_Design_TabName"),
      setRef: setReferenceElement
    }
  );
};
export {
  PollDesignButton
};
//# sourceMappingURL=poll-design-button.js.map
